import { Injectable } from '@angular/core';

@Injectable()
export class BrowserNotificationService {
  private _isWindowFocused = false;

  public get isWindowFocused(): boolean {
    return this._isWindowFocused;
  }

  public onWindowFocus(): void {
    this._isWindowFocused = true;
  }

  public onWindowBlur(): void {
    this._isWindowFocused = false;
  }

  public async requestPermission(): Promise<void> {
    if (Notification.permission === 'default') {
      await Notification.requestPermission();
    } else if (Notification.permission === 'denied') {
      alert(
        'Please turn on notifications. To do this, right-click on the icon to the left of the domain in the address bar of the browser. ',
      );
    }
  }

  public async showNotification(title: string, options?: NotificationOptions): Promise<Notification> {
    if (Notification.permission !== 'granted') {
      await this.requestPermission();
    }

    if (!this._isWindowFocused) {
      return new Notification(title, {
        icon: '/assets/logotype.png',
        ...options,
      });
    }
  }
}
